import { useEffect, useState } from "react";///
import { DownOutlined, UpOutlined, EyeFilled } from "@ant-design/icons";
import useModal from "../../../../../Hooks/useModal";///
import ModalFavGrants from "../ModalFavGrants";
import Loader from "../../../../../Components/Shared/Loader";///
import useLoading from "../../../../../Hooks/useLoading";///
import './styles.css';///
import { IOpportunitiesLines, IOpportunitiesProjects } from "../../../../../Interfaces/IOpportunitiesPanels";////
import { GetGrantByIdAPI } from "../../../../../API/GrantsAPI";///
import { IResponseProps } from "../../../../../Interfaces/IResponseProps";///
import { toast } from "react-toastify";//  refazer
import { GrantsModel } from "../../../../../Models/GrantsModel";////

import type { CollapseProps } from "antd";
import { Typography, Collapse, Button } from "antd";

interface ICollaspeLinesHeaderProps {
    title?: string;
    lines?: IOpportunitiesLines[]
}


const CollapseLinesHeaderComponent = (props: ICollaspeLinesHeaderProps) => {
    const { loading, toggleLoading } = useLoading();
    const [open, setOpen] = useState(false);
    const { showModal, toggleShowModal } = useModal();
    const [projectsList, setProjectsList] = useState<IOpportunitiesProjects[]>([]);
    const [grant, setGrant] = useState<GrantsModel>();

    const items: CollapseProps['items'] = [
        {
            label: <><Typography aria-level={2}>{props.title}</Typography></>,
            key: props.title,
            children:

                <div id="collapse" className=''>
                    <div className='d-flex flex-column align-items-start'>
                        {props.lines?.map((linesContent, i) => {
                            return (
                                <div key={i} className="mt-2 mb-2 p-2 card-collapse">
                                    <Typography aria-level={2} className="grants-colapse-name" >{linesContent.grantsName}</Typography>
                                    <Typography aria-level={4} className="mt-2 mb-2 grants-colapse-description">{linesContent.grantsDescription}</Typography>

                                    <div className="d-flex ustify-content-between align-items-start mt-4">
                                        {linesContent.projectsHistorics?.map((project, ind) => {
                                            return (
                                                <div key={ind} className="project-card-div mb-0">
                                                    {project &&
                                                        <Typography className="project-card-text">{project.projectName ?? ""}</Typography>
                                                    }
                                                </div>
                                            )
                                        })}

                                        <div className='d-flex align-items-start flex-column ms-auto p-2'>
                                            <Button className="blue align-self-start align-items-start" style={{ border: "none" }} onClick={() => getGrant(linesContent.favoriteGrantsId, linesContent.projectsHistorics)}>
                                                <EyeFilled className="align-self-start" />
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>

        },
    ];

    const getGrant = async (grantsId: string, listProjetcs?: IOpportunitiesProjects[]) => {
        try {
            debugger
            toggleLoading(true);
            setProjectsList(listProjetcs ?? []);
            await GetGrantByIdAPI(grantsId ?? "", 0).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setGrant(resp.data);
                }
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toggleLoading(false);
            toast.error(error);
        }
    }

    useEffect(() => {
        if (grant != undefined) {
            toggleShowModal();
        }
    }, [grant]);

    useEffect(() => {
        if (!showModal) {
            setProjectsList([]);
            setGrant(undefined);
        }
    }, [showModal]);

    useEffect(() => {
        console.log(open);
    }, [open])

    return (
        <>
            {loading && <Loader />}
            <Collapse
                expandIcon={({ isActive }) =>
                    isActive ? <UpOutlined className="font-awesome-icon" /> : <DownOutlined className="font-awesome-icon" />
                }
                onChange={() => setOpen(!open)}
                expandIconPosition='end'
                style={open ? { background: "#00000003" } : { background: "#FFFFFF" }}
                items={items} />

            <ModalFavGrants
                show={showModal}
                toggleShowModal={toggleShowModal}
                grants={grant}
                projects={projectsList} />
        </>
    )
}

export default CollapseLinesHeaderComponent;